// extracted by mini-css-extract-plugin
export default {"modal-background":"Modal_modal-background__GTBcQ","Modal":"Modal_Modal__qVTgh","Content":"Modal_Content__d2d1W","button-container":"Modal_button-container__DPZGQ"};